
const state = {
    showInvoiceModal: false,
    showPaymentModal: false,
    showCreditDebitModal: false,
    showInvoiceReceiptPaperModal: false,
    showScheduledInvoice: false,
    selectedInvoice: null,
    openInvoiceFilterDialog: false,
};

const getters = {
    getShowInvoiceModal(state){
        return state.showInvoiceModal;
    },
    getShowPaymentModal(state){
        return state.showPaymentModal;
    },
    getShowCreditDebitModal(state){
        return state.showCreditDebitModal;
    },
    getShowInvoiceReceiptPaperModal(state){
        return state.showInvoiceReceiptPaperModal;
    },
    getShowScheduledInvoice(state){
        return state.showScheduledInvoice;
    },
    getOpenInvoiceFilterDialog(state){
        return state.openInvoiceFilterDialog;
    },
    getSelectedInvoice(state, getters){
        if(!state.selectedInvoice){
            state.selectedInvoice = getters.getNewInvoice;
        }
        return state.selectedInvoice;
    },

    getNewInvoice(state, getters, rootGetters){
        return {
            code: '',
            sells_id: '',
            purchases_id: '',
            installment: '',
            sell: rootGetters['Sell/getNewSell'],
                // this.$store.getters.getNewSell,


            types_payment_condition_id: '',
            due_date: '',
            emission_date: '',
            total_value: '',
            pendent_value: '',
            detail: '',
            created_at: '',
        };
    },
};

const mutations = {
    setShowInvoiceModal(state, payload){
        state.showInvoiceModal = payload;
    },
    setShowPaymentModal(state, payload){
        state.showPaymentModal = payload;
    },
    setShowCreditDebitModal(state, payload){
        state.showCreditDebitModal = payload;
    },
    setShowInvoiceReceiptPaperModal(state, payload){ //this also works for new invoice
        state.showInvoiceReceiptPaperModal = payload;
    },
    setShowScheduledInvoice(state, payload){ //this also works for new invoice
        state.showScheduledInvoice = payload;
    },
    setSelectedInvoice(state, payload){ //this also works for new invoice
        state.selectedInvoice = payload;
    },
};

const actions = {
    setShowInvoiceModal({commit}, payload){
        commit('setShowInvoiceModal', payload);
    },
    setShowPaymentModal({commit}, payload){
        commit('setShowPaymentModal', payload);
    },
    setShowCreditDebitModal({commit}, payload){
        commit('setShowCreditDebitModal', payload);
    },
    setShowInvoiceReceiptPaperModal({commit}, payload){
        commit('setShowInvoiceReceiptPaperModal', payload);
    },
    setShowScheduledInvoice({commit}, payload){
        commit('setShowScheduledInvoice', payload);
    },
    setSelectedInvoice( {commit}, payload){
        commit('setSelectedInvoice', payload);
    },
    async downloadPDF({commit}, payload){
        return new Promise((resolve, reject) => {
            const options = {
                type: 'dataURL'
            };
            let output = this.$html2canvas(payload, options);
            resolve(output);
        });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};

